import styled from 'styled-components';

import Text from '@polyai/ui/components/atoms/Text';
import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${themeSpacing.sm1};
`;

export const HeaderButtonsWrapper = styled.div`
  display: flex;
  gap: ${themeSpacing.xs3};
  align-items: center;
`;

export const CardTitleSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const CardTitle = styled.div`
  overflow: hidden;


  font-size: ${text.size.header.regular};
  font-weight: ${text.weight.bold};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardContainer = styled.div`
  flex-grow: 1;
  min-width: ${themeSpacing.xxl1};
  border: 1px solid transparent;
  border-radius: ${themeSpacing.radiusMedium};
`;

export const Header = styled.div<{ $isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    margin-bottom: ${({ $isCollapsed }) => ($isCollapsed ? 0 : themeSpacing.sm3)};
`;

export const ResponseMetricsLabel = styled.div`
  justify-content: space-between;

  width: 100%;
  margin-bottom: ${themeSpacing.xs2};

  font-size: ${text.size.body.small};
  font-weight: ${text.weight.normal};
  color: ${themeColors.textSecondary};
`;

export const HelperText = styled.div`
  color: ${themeColors.textHelper};
`;

export const TitleText = styled(Text)`
  display: flex;
  gap: ${themeSpacing.xs1};
  align-items: center;
`;
